import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { DriverDocumentsPage } from 'routes/paths';
import { DocumentTypeEnum } from 'common/document/enums/document-type.enum';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import MessageBanner from '../../../../components/MessageBanner';
import { YesNoOptionsSelector } from '../../../../components/ChipOptionsSelector';
import documentRequestCandidateService from '../../../../store/document-request-candidate/service';

export interface IDOTMedicalQuestionsProps {
  className?: string;
}

function DOTMedicalQuestions(props: IDOTMedicalQuestionsProps) {
  const { documentId, documentRequestId } = useParams();
  const [isReturnToWork, setIsReturnToWork] = React.useState(false);

  const navigate = useNavigate();

  const [addDocumentToRequest] =
    documentRequestCandidateService.endpoints.addDocumentToRequest.useMutation();

  const handleNextClick = async () => {
    if (isReturnToWork && documentRequestId) {
      await addDocumentToRequest({
        documentType: DocumentTypeEnum.RETURN_TO_WORK,
        documentAlias: 'return-to-work',
        documentRequestId: documentRequestId,
        addRelationToDocument: documentId,
      });
    }
    navigate(`${DriverDocumentsPage}?from=${DocumentTypeEnum.DOT_MEDICAL}`);
  };

  return (
    <div className={clsx(styles.root, props.className)}>
      <h3>Is this a return to work?</h3>
      <div className={styles.questionWrapper}>
        <YesNoOptionsSelector
          className={styles.mainYesNoAnswer}
          isChecked={isReturnToWork}
          onChange={(isSelected: boolean) => {
            setIsReturnToWork(isSelected);
          }}
        />
      </div>
      {isReturnToWork && (
        <MessageBanner className={styles.manualUpladMessage}>
          You will need to submit the Return to Work document on the next step.
        </MessageBanner>
      )}
      <div className={styles.actions}>
        <ButtonWithArrowIcon type="button" onClick={handleNextClick}>
          Next
        </ButtonWithArrowIcon>
      </div>
    </div>
  );
}

export default DOTMedicalQuestions;
